import { merge } from 'ramda';
// Actions
export const importUsersActions = {
  request: 'IMPORT_USERS_REQUEST',
  meritRequest: 'IMPORT_MERIT_USERS_REQUEST',
  personaRequest: 'IMPORT_PERSONA_USERS_REQUEST',
  personaAbsencesRequest: 'IMPORT_PERSONA_ABSENCES_REQUEST',
  personaSuccess: 'IMPORT_PERSONA_USERS_SUCCESS',
  success: 'IMPORT_USERS_SUCCESS',
  fail: 'IMPORT_USERS_FAIL',
  dump: 'IMPORT_USERS_DUMP',
  update: 'USER_UPDATE_AXAPTA'
};

export const requestImportMeritUsers = (params) => ({ type: importUsersActions.meritRequest, params });
export const requestImportPersonaUsers = (params) => ({ type: importUsersActions.personaRequest, params });
export const requestImportPersonaAbsences = (params) => ({ type: importUsersActions.personaAbsencesRequest, params });
export const requestImportUsers = (params) => ({ type: importUsersActions.request, params });
export const dumpImportInfo = () => ({ type: importUsersActions.dump });
export const requestUpdateFromAxapta = (params) => ({ type: importUsersActions.update, params });

const initialState = {
  fetching: false,
  list: [],
  personaSuccess: {},
  errors: ''
};

const importUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case importUsersActions.meritRequest:
    case importUsersActions.request:
    case importUsersActions.personaRequest:
    case importUsersActions.personaAbsencesRequest:
    case importUsersActions.update:
      return merge(state, { fetching: true, errors: '' });
    case importUsersActions.success:
      return merge(state, { list: action.payload, fetching: false, errors: '' });
    case importUsersActions.personaSuccess:
      return merge(state, { personaSuccess: action.payload, fetching: false, errors: '' });
    case importUsersActions.fail:
      return merge(state, { fetching: false, errors: action.payload });
    case importUsersActions.dump: {
      return initialState;
    }
    default:
      return state;
  }
};

export default importUsersReducer;
